<!-- Notification Container - Always visible -->
<app-notification-container></app-notification-container>

<!-- Session Warning Modal -->
<session-warning-modal></session-warning-modal>

<!-- Loading State -->
<div *ngIf="isAuthLoading || (!isNavigationReady && authBase.authenticated)" class="member-roster__loading">
  <acs-loading-spinner size="large" [message]="getLoadingMessage()" />
</div>

<!-- Main Application - Show when authenticated -->
<div *ngIf="!isAuthLoading && authBase.authenticated" class="app-main">
  <!-- Impersonation Corner Indicator - Global positioning, outside content area -->
  <div class="impersonation-corner-indicator"></div>
  
  <!-- Navigation - Always load when authenticated -->
  <acs-navigation
    [collapsed]="isNavCollapsed"
    (collapseToggle)="onNavCollapseToggle($event)"
    (userMenuClick)="onUserMenuAction($event)"
    (navigationReady)="onNavigationReady($event)">
  </acs-navigation>

  <!-- Main Content with Router Outlet - Only show when navigation is ready -->
  <div *ngIf="isNavigationReady" class="acs-app" [ngClass]="{
    'acs-content-with-navigation': true, 
    'acs-content-with-navigation--collapsed': isNavCollapsed,
    'with-impersonation-banner': (impersonationService.sessionStatus$ | async)?.isImpersonating
  }">
    <!-- Impersonation Banner - Positioned within main content area -->
    <acs-impersonation-banner [isNavCollapsed]="isNavCollapsed"></acs-impersonation-banner>
    
    <router-outlet></router-outlet>
  </div>
</div>

<!-- Login View -->
<div *ngIf="!isAuthLoading && !authBase.authenticated" class="app-login">
  <acs-login-page></acs-login-page>
</div>